import type { FC } from 'react';

import { Form } from '../../Form.tsx';
import type { GenericFormProps } from '../../GenericFormProps.ts';
import { Password } from './Password.tsx';
import { schema } from './schema.ts';

export const PasswordForm: FC<GenericFormProps<typeof Password, typeof schema>> = ({ onSubmit, buttonSlot }) => (
  <Form
    buttonSlot={buttonSlot}
    defaultValues={{ password: '' }}
    formContentElement={Password}
    schema={schema}
    onSubmit={onSubmit}
  />
);
